module.exports = __webpack_public_path__ + "static/img/Servicios_Ojo.1879068.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/icons/Servicios_Ojo.png
// module id = 51
// module chunks = 0